import { BasicsClass } from '@/common/BasicsClass';

export class MerchantPosterManageAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getMerchantPosterTableList', {
            url: '/admin/poster/merchant/list',
            name: 'list',
            label: '海报列表'
        }],
        // ['add', {
        //     url: '/admin/shop/add',
        //     name: 'add',
        //     label: '海报新增',
        //     // hidden: true
        // }],

        // ['edit', {
        //     url: '/admin/shop/update',
        //     name: 'edit',
        //     label: '海报编辑',
        // }],
        ['delete', {
            url: '/admin/poster/merchant/delete',
            name: 'delete',
            label: '海报删除',
        }],
        // ['getProvince', {
        //     url: '/admin/shop/province',
        //     name: 'province-list',
        //     label: '省份列表（下拉选择）'
        // }],
        // ['getCity', {
        //     url: '/admin/shop/city',
        //     name: 'city-list',
        //     label: '地级市列表（下拉选择）'
        // }],
    ])

    public getMerchantPosterTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getMerchantPosterTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // public addMerchantPoster(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls

    //     const url = apiUrls.get('add').url

    //     this.BasicPost(url, {
    //         ...params
    //     }, false, false, false, successCb, failCb, showLoading)
    // }

    // public editMerchantPoster(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls

    //     const url = apiUrls.get('edit').url

    //     this.BasicPost(url, {
    //         ...params
    //     }, false, false, false, successCb, failCb, showLoading)
    // }

    public delete(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('delete').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    // public getProvince(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls

    //     const url = apiUrls.get('getProvince').url

    //     this.BasicPost(url, {
    //         ...params
    //     }, false, false, false, successCb, failCb, showLoading)
    // }

    // public getCity(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    //     const apiUrls = this.apiUrls

    //     const url = apiUrls.get('getCity').url

    //     this.BasicPost(url, {
    //         ...params
    //     }, false, false, false, successCb, failCb, showLoading)
    // }

}